<script setup lang="ts">
import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogTrigger,
    DialogScrollContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import ManageCustomerView from "./ManageCustomerView.vue";
import { UserCog } from "lucide-vue-next";

const props = defineProps<{
    storeId: string;
    userId: string;
}>();

</script>

<template>
    <Dialog v-if="props.storeId && props.userId">
        <DialogTrigger as-child>
            <Button class=""
                    variant="outline">
                <UserCog />
                Customer
            </Button>
        </DialogTrigger>
        <DialogScrollContent class="sm:max-w-lg">
            <DialogHeader>
                <DialogTitle>Manage customer</DialogTitle>
            </DialogHeader>
            <ManageCustomerView :store-id="props.storeId"
                                :user-id="props.userId" />
        </DialogScrollContent>
    </Dialog>
</template>